import { render } from "./MdlDetalleProveedor.vue?vue&type=template&id=044a5366&scoped=true"
import script from "./MdlDetalleProveedor.vue?vue&type=script&lang=js"
export * from "./MdlDetalleProveedor.vue?vue&type=script&lang=js"

import "./MdlDetalleProveedor.vue?vue&type=style&index=0&id=044a5366&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044a5366"]])

export default __exports__